/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Diet_Title_TailInputs */

const en_portal_diet_title_tail = /** @type {(inputs: Portal_Diet_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The calories count themselves.`)
};

const pl_portal_diet_title_tail = /** @type {(inputs: Portal_Diet_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalorie policzą się same.`)
};

/**
* | output |
* | --- |
* | "The calories count themselves." |
*
* @param {Portal_Diet_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_diet_title_tail = /** @type {((inputs?: Portal_Diet_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Diet_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_diet_title_tail(inputs)
	return en_portal_diet_title_tail(inputs)
});